import { FC, useMemo } from "react";
import { ChannelNamContainer } from "./styles";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { TeamHolder } from "shared/components/TeamCard/TeamHolder";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";
import { getChannelColor } from "shared/pages/teams/components/support/getChannelColor";
import { useTeamContext } from "../provider/TeamContext";
import { useProfile } from "@brg/auth";
import { TeamEditTooltip } from "./TeamEditTooltip";

export const ChannelDefaultEmblem: FC<{team: any}> = ({ team }) => {
    const { t, i18n: { language } } = useTranslation()
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);
    const profile = useProfile();
    const canEdit = !!team?.teamId && !!profile && !!team?.ownersIDs?.includes(profile?.accountId);

    const { teamInfoSync } = useTeamContext()

    const calcCoverBg = useMemo(() => {
        return team && getChannelColor(team?.additionalInfo?.lmsCourseType)
    } , [team])

    const calcCourseType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseModuleFormat
        return t(`autochannels.cover.course_type_${type}`)
    } , [team, language])

    const cover = useMemo(() => {
        if (channelType === ModerationType.ChannelGroupOrCourse) {
            const courseNameLabel = teamInfoSync?.courseName || team?.name;
            const groupLabel = teamInfoSync?.groupTitle || teamInfoSync?.groupName || team?.name;
            return (
                <ChannelNamContainer bg={calcCoverBg}>
                    {canEdit && <TeamEditTooltip teamId={team.teamId} position="absolute"/>}
                    <FlexBox direction="column">
                        <span className="course-lms_type">{courseNameLabel}</span>
                        <span className="course-name">{groupLabel}</span>
                        <span className="course-type">{calcCourseType}</span>
                    </FlexBox>
                </ChannelNamContainer>
            )
        }
        return <TeamHolder team={team}/>
    } , [teamInfoSync, calcCoverBg, team, channelType, calcCourseType, language, canEdit])

    return cover
}import { FC, useMemo } from "react";
import { ChannelNamContainer } from "./styles";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { TeamHolder } from "shared/components/TeamCard/TeamHolder";
import { useTranslation } from "react-i18next";
import { FlexBox } from "@brg/ui";
import { getChannelColor } from "shared/pages/teams/components/support/getChannelColor";
import { useTeamContext } from "../provider/TeamContext";
import { useProfile } from "@brg/auth";
import { TeamEditTooltip } from "./TeamEditTooltip";

export const ChannelDefaultEmblem: FC<{team: any}> = ({ team }) => {
    const { t, i18n: { language } } = useTranslation()
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);
    const profile = useProfile();
    const canEdit = !!team?.teamId && !!profile && !!team?.ownersIDs?.includes(profile?.accountId);

    const { teamInfoSync } = useTeamContext()

    const calcCoverBg = useMemo(() => {
        return team && getChannelColor(team?.additionalInfo?.lmsCourseType)
    } , [team])

    const calcCourseType= useMemo(() => {
        const type = team && team?.additionalInfo?.lmsCourseModuleFormat
        return t(`autochannels.cover.course_type_${type}`)
    } , [team, language])

    const cover = useMemo(() => {
        if (channelType === ModerationType.ChannelGroupOrCourse) {
            const courseNameLabel = teamInfoSync?.courseName || team?.name;
            const groupLabel = teamInfoSync?.groupTitle || teamInfoSync?.groupName || team?.name;
            return (
                <ChannelNamContainer bg={calcCoverBg}>
                    {canEdit && <TeamEditTooltip teamId={team.teamId} position="absolute"/>}
                    <FlexBox direction="column">
                        <span className="course-lms_type">{courseNameLabel}</span>
                        <span className="course-name">{groupLabel}</span>
                        <span className="course-type">{calcCourseType}</span>
                    </FlexBox>
                </ChannelNamContainer>
            )
        }
        return <TeamHolder team={team}/>
    } , [teamInfoSync, calcCoverBg, team, channelType, calcCourseType, language, canEdit])

    return cover
}